module.exports = "/static/assets/654eddd856b9044e225152576d5e571b.png";